import styled from "styled-components";

export const BodyContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 24px 82px 0 80px;

  .space-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  @media only screen and (max-width: 1050px) {
    padding: 12px 60px 0 60px;
  }

  @media only screen and (max-width: 768px) {
    padding: 12px 45px 0 30px;
  }
`;

export const ContainerItem = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  margin-top: 68px;
  height: auto;

  .toggle-label {
    margin-left: 15px;
  }

  @media only screen and (max-width: 950px) {
    display: flex;
    flex-direction: column;
    margin-top: 36px;
  }
`;

export const TitleContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 120px;
  height: 20px;
`;

export const AttributeContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 400px;

  @media only screen and (max-width: 950px) {
    margin-top: 16px;
    width: 100%;
  }

  
`;

export const TextLength = styled.span`
  align-self: end;
  margin-top: 4px;
  color: ${(props) => props.theme.colors.placeholder};
`;
